import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import ModelViewer from "../../../ModelViewer";
import viewerContentStyle from "./viewerContentStyle";

//different views based on the activeView prop
const ViewerContent = ({ activeView, OnFullscreenXeokit, OnFullscreenVC }) => {

    const classes = viewerContentStyle();

    return (
        <Box>
            {/* Render IFC view */}
            {activeView === "IFC" && (
                <Box className= {classes.ifcContainer}>
                    <ModelViewer hasStandaloneNavber={false} />
                    <Tooltip title="Fullscreen Mode" arrow placement="bottom">
                    <IconButton
                        onClick={OnFullscreenXeokit}
                        className={classes.fullscreenButton}
                    >
                        <FullscreenIcon sx={{ fontSize: "35px" }} />
                    </IconButton>
                    </Tooltip>
                </Box>
            )}

            {/* Render VC view */}
            {activeView === "City" && (
                <Box className={classes.vcContainer}>
                    <iframe
                        src="./VCpublisher/index.html"
                        className={classes.vcStyle}
                        title="VC Viewer"
                    />
                    <Tooltip title="Fullscreen Mode" placement="bottom">
                        <IconButton
                            onClick={OnFullscreenVC}
                            className={classes.fullscreenButtonVc}
                        >
                            <FullscreenIcon sx={{ fontSize: "35px" }} />
                        </IconButton>


                    </Tooltip>
                </Box>
            )}
        </Box>
    );
};
export default ViewerContent;